import { render } from "./App.vue?vue&type=template&id=750a7098"
const script = {}

import "./App.vue?vue&type=style&index=0&id=750a7098&lang=less"

import exportComponent from "D:\\workspace\\payment-system-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__